module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("80j2B"))).then(() => parcelRequire('ljYL6'));